import { useMemo } from 'react';
import { useWorkFlowCanvas } from '../../../../../contexts/CampaignFlowProvider';

export const useIsInFlowSelector = () => {
  const { state } = useWorkFlowCanvas();

  return useMemo(() => !!state.nodes.find(s => s.id === 'send-email'), [state.nodes]);
};
